import React from 'react';

const Search = () => {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.7491 36.1686C30.4697 36.1686 36.7285 29.91 36.7285 22.1894C36.7285 14.469 30.4697 8.21033 22.7491 8.21033C15.0287 8.21033 8.77002 14.469 8.77002 22.1894C8.77002 29.91 15.0287 36.1686 22.7491 36.1686Z"
        fill="#EFF7FF"
      />
      <path
        d="M22.7491 9.68941C26.0643 9.68941 29.2437 11.0064 31.5879 13.3506C33.932 15.6948 35.2491 18.8742 35.2491 22.1894C35.2491 25.5046 33.932 28.684 31.5879 31.0282C29.2437 33.3725 26.0643 34.6894 22.7491 34.6894C19.4339 34.6894 16.2545 33.3725 13.9103 31.0282C11.5661 28.684 10.2491 25.5046 10.2491 22.1894C10.2491 18.8742 11.5661 15.6948 13.9103 13.3506C16.2545 11.0064 19.4339 9.68941 22.7491 9.68941ZM22.7491 4.48108C18.0543 4.4866 13.5533 6.35408 10.2335 9.67383C6.91373 12.9936 5.04629 17.4946 5.04077 22.1894C5.04077 24.5148 5.49879 26.8175 6.38873 28.9661C7.27865 31.1146 8.58306 33.0667 10.2274 34.7111C11.8718 36.3555 13.8239 37.6598 15.9724 38.5498C18.1209 39.4396 20.4236 39.8977 22.7491 39.8977C25.0754 39.9005 27.3793 39.4444 29.5291 38.5555C31.6787 37.6665 33.632 36.3621 35.2768 34.7171C36.9218 33.0723 38.2262 31.119 39.1151 28.9694C40.0041 26.8196 40.4601 24.5157 40.4574 22.1894C40.4574 17.4929 38.5918 12.9887 35.2708 9.66773C31.9497 6.34677 27.4456 4.48108 22.7491 4.48108Z"
        fill="#737A83"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.2182 30.9536L46.4682 42.2244L42.782 45.9038L31.532 34.633L35.2182 30.9536Z"
        fill="#737A83"
      />
    </svg>
  );
};

export default Search;
